export const PPC_CLOSE = 'ppcclose';
